<template>
    <div class="layout-default">
        <my-header></my-header>

        <div class="page-body">
            <slot>
                <nuxt />
            </slot>
        </div>

        <right-bar></right-bar>

        <my-footer></my-footer>
    </div>
</template>

<script>
import rightBar from '../pages/index/components/right-bar.vue';
// import IS_MODEL from '@mixins/is-model';
export default {
    // mixins:[IS_MODEL],
    name: 'layout-default',
    components: { rightBar },
    data() {
        return {};
    },
    methods: {},
    mounted() {
        // this.$store.dispatch("server/checkTime");
    },
};
</script>

<style scoped lang="scss" media=print>
.layout-default {
    background-color: #fff;
    width: 100%;
}

.page-body {
}
</style>

<style type="text/css" media=print>
    @media print {
        @page {
            size: auto;
        }

        body{
            /* 打印预览时缩放比例默认50% */
            zoom: 50%;
        }
        body, html{
            height: auto!important;
            /* 打印预览时强制勾选打印的背景图片 */
            -webkit-print-color-adjust: exact; 
        }
    }
</style>
